 import React from "react";
 import { DownloadOutlined, EyeOutlined} from "@ant-design/icons";
 import DetailBusiness from "../component/detailMerchent.js";
import { Skeleton,Modal } from "antd";
import { Button,Row,Col,CardBody,Card } from "reactstrap";
import TableContainerMin from "../../../../common/TableContainerMin.js";
 const VerificationJournalier = ({
  searchTerm,
  setSearchTerm,
  openModal,
  renderTabs,
  columnsJournalier,
  filteredMerchents,
  isLoading,
  isError,
  empty,
  modalState,
  setModalState,
  selectedMerchant,
  setIsModalOpen,
  isModalOpen,
  modalPosition,
  handleDetail,
  currentuser
}) => {
  return (
     <React.Fragment>
      <div className="header-actions w-100 mb-2">
      <div className="col-6 p-0">
            <input
              type="text"
              placeholder="Rechercher un rapport..."
              className="form-control search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          
          <Button className="filtrer" onClick={() => openModal("merchent-trier")}>
            <DownloadOutlined  style={{fontSize: "20px"}} />
            Exporter
          </Button>
        </div>
         <Row className="w-100 m-0">
        <Col className="w- p-0">
        <Card className="h-100 w-100" style={{ border: "1px solid #E3E3E3" }}>
        <CardBody className="p-0 ">
        {renderTabs}
        <TableContainerMin
          columns={columnsJournalier}
          data={filteredMerchents}
          isGlobalFilter={false}
          customPageSize={10}
          isLoading={isLoading}
          className="custom-header-css"
          divClass="table-responsive "
          tableClass="table w-100 mb-0 no-column-borders"
          theadClass="custom-thead"
          SearchPlaceholder="Recherche..."
        />
        {isLoading && !isError && (
          <div className="text-center"><Skeleton/> </div>
        )}
        {filteredMerchents && filteredMerchents.length === 0 && !isLoading && (
          <div className="text-center"><img
      src={empty} 
      alt="Liste vide"
      style={{ width: "150px", marginBottom: "10px" }}
    /></div>
        )}
      </CardBody>
    </Card>
  </Col>
</Row>
  <Modal
    open={isModalOpen}
    onCancel={() => setIsModalOpen(false)}
    footer={null}
    width={180}
    style={{
      background:"#FFFFFF",
      position: "absolute",
      top: modalPosition.top,
      left: modalPosition.left,
      borderRadius: 10,
      border: "1px solid #DFDFDF",
      padding: 0,
      boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    }}
   bodyStyle={{ padding: "8px 1px" }}

    mask={false}
    closable={false}
  >
    <div
      style={{
        display: "flex",
        flexDirection: "column",
         alignItems: "flex-start",
        gap: "12px",
      }}
    >
      <a
        onClick={() => {
          setModalState({
            type: "detail",
            data: selectedMerchant
          });
          setIsModalOpen(false);
        }}
        style={{ display: "flex", alignItems: "start", gap: "8px", cursor: "pointer" }}
      >
        <EyeOutlined style={{ fontSize: "20px" }} />
        <span className="actions">Voir rapport</span>
      </a>
      <a
      onClick={() => {
         handleDetail(selectedMerchant)
        setIsModalOpen(false);
      }}
      style={{ display: "flex", alignItems: "start", gap: "8px", cursor: "pointer" }}
    >
      <DownloadOutlined  style={{fontSize: "20px"}} />
        <span class="actions">Exporter rapport</span>
      </a>
      </div>
    </Modal>
        {isLoading ? (
      <Skeleton />
    ) : (
      <DetailBusiness
        modal={modalState.type === "detail"}
        setModal={setModalState}
        toggle={() => openModal("detail", modalState.data)}
        selectedMerchent={modalState.data}
        currentuser={currentuser}
        isLoading={false}
      />
    )}
    </React.Fragment>
  );
} 
export default VerificationJournalier;
